<template>
  <v-container>
    <div class="fid-player-overlay" ref="fid-player-overlay">
      <canvas ref="fid-player-canvas" height="0"></canvas>
    </div>


    <vue-plyr v-if="isVimeoEmbed" ref="plyr" :options="options">
      <div class="plyr__video-embed">
        <iframe
          :src="`${vimeoUrl}?loop=false&byline=false&portrait=false&title=false&speed=true&responsive=true&transparent=0&gesture=media`"
          allowtransparency allow="fullscreen;"></iframe>
      </div>
    </vue-plyr>
    <vue-plyr v-else-if="isYoutubeEmbed" ref="plyr" :options="options">
      <div class="plyr__video-embed">
        <iframe
          :src="`${vimeoUrl}?loop=false&byline=false&portrait=false&title=false&speed=true&responsive=true&transparent=0&gesture=media`"
          allowtransparency allow="fullscreen;"></iframe>
      </div>
    </vue-plyr>
    <vue-plyr v-else-if="isFid" ref="plyr" :options="options">
      <video ref="vid" :poster="poster" preload="none">
        <source v-for="filmFile in supported" :key="filmFile.id" :src="filmFile.path" :type="filmFile.type"
          :size="filmFile.quality" />
      </video>
    </vue-plyr>
    <span v-else>No host</span>

    <div :class="stripClass" v-if="playerReady && strip">
      <v-img ref="fid-strip-overlay" v-if="strip" :max-height="stripHeight" :src="strip"
        @click="stripClick" :width="stripWidth" class="fid-absolute"/>
      <canvas ref="fid-strip-canvas" class="fid-strip-canvas"></canvas>
    </div>

    <v-row class="d-flex mt-4 mx-1" v-if="big && player" sm="6">
      <v-card tile class="align-self-center " flat>
        <img :src="hostLogo" class="fid-logo-size mt-2" />
      </v-card>

      <v-card tile class="align-self-center " flat>
        <v-chip v-if="videoRatio" :color="arColor" label small>
          <span class="caption">{{ videoRatio }}</span>
        </v-chip>
      </v-card>
      <v-card tile class="align-self-center" flat>
        <v-chip v-if="fps" :color="frColor" label small>
          <span class="caption">{{ fps }}</span>
        </v-chip>
      </v-card>
      <v-card tile class="align-self-center" flat>
        <v-chip v-if="levelBitrate" :color="brColor" label small>
          <span class="caption">{{ Math.round(levelBitrate / 1000) }}kbps</span>
        </v-chip>
      </v-card>
      <v-card tile class="align-self-center" flat>
        <v-chip v-if="videoFormat" :color="formatColor" label small>
          <span class="caption">{{ videoFormat }}</span>
        </v-chip>
      </v-card>
      <v-card tile class="align-self-center" flat>
        <v-chip v-if="showSheek" :color="seekColor" label small>
          <span class="caption">{{ frameNumber }}</span>
        </v-chip>
      </v-card>
      <v-spacer></v-spacer>
      <v-card tile class="align-self-end ml-2 v-input--reverse" flat>
        <v-switch v-model="showTracking" label="Visualize" :disabled="trackingDisabled"></v-switch>
      </v-card>
    </v-row>

  </v-container>
</template>
<script>
// TODO catch change quality event to fix up source info display

import { getIconColor } from '@/js/store'
import { drawBox, clearCanvas } from '@/js/canvas'
import vimeoLogo from '@/assets/vimeo_icon_white_on_blue.png'
import hitoLogo from '@/assets/bluehito.png'
import Hls from 'hls.js'
import { mapState, mapMutations } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import { SlimLabels } from '@/gql'

export default {
  components: {

  },
  props: {
    poster: String,
    filmFiles: Array,
    autoplay: Boolean,
    big: Boolean,
    filmMaster: Object,
    vimeoFile: Object,
    playerMethod: String,
  },
  watch: {
    poster: {
      handler() {
        this.setPoster()
      },
    },

    playSegment(segment) {
      if (this.playerReady && segment) {
        const frameDetails = this.getFrameDetails({
          segment,
          frameRate: this.floatRate,
        })
        if (frameDetails) {
          this.player.currentTime = frameDetails.seek
          this.patchPlayerStats({
            floatRate: this.floatRate
          })
        }
      }
      this.setPlaySegment(null)
    },
    filmFiles: {
      immediate: false,
      handler() {
        this.newFiles()
        this.setSources()
      },
    },
  },

  mounted() {
    this.newFiles()
  },

  methods: {
    stripClick(evt) {
      const x = evt.offsetX
      const width = evt.currentTarget.offsetWidth
      // now calculate the time offset
      // skip if outside range
      if (x < 0 || x > width) return null
      // new time
      const stripTarget = x / width * this.filmMaster.duration
      this.player.currentTime = stripTarget
    },
    setStripCanvas() {
      if (!this.stripElem && this.strip) {
        this.stripElem = document.querySelector('.strip-class')
      }
      const stripElem = this.stripElem
      if (!stripElem) return null

      const d = this.sizeCanvas({
        refName: 'fid-strip-canvas',
        container: stripElem,
        forceHeight: this.stripHeight
      })
      // if we don't already have a 
      if (!this.stripCtx) {
        this.stripCtx = d.getContext('2d')
      }
    },

    setPoster() {
      this.player.poster = this.poster
    },

    // gray out time passed

    stripProgress(currentTime) {

      this.setStripCanvas()
      if (!this.stripCtx) return null

      // clear whatever was there before
      clearCanvas(this.stripCtx)
      const piece = currentTime / this.filmMaster.duration
      const right = piece
      const pos = {
        top: 0,
        bottom: 1,
        left: 0,
        right
      }
      drawBox(this.stripCtx, pos, {
        fill: '#cccccc',
        opacity: 0.2
      })
    },

    // this can be used to signal some action to the player after some kind of seek
    dealWithPlayerAction() {
      const val = this.playerAction
      if (val === 'play') {
        // this may be async on some browsers, but we don't need to wait for the response
        if (this.playerReady && !this.player.playing) this.player.play()
      } else if (val === 'pause') {
        if (this.playerReady && this.player.playing) this.player.pause()
      } else if (val !== null) {
        console.log('...unknown playeraction', val)
      }
      // we've done as requested so signal nothing else to do
      if (this.playerAction) {
        this.setPlayerAction(null)
      }
    },

    setSources() {
      // for some reason the reacivity of the <video></video> tab doesnt set new values.
      // so we'll use the api

      this.player.source = {
        type: 'video',
        sources: this.supported.map((f) => {
          // get a src as an artifact if available otehrwise use the path
          const src =
            (f.FilmFileArtifact &&
              f.FilmFileArtifact.SignedUrl &&
              f.FilmFileArtifact.SignedUrl.url) ||
            f.path
          return {
            src,
            type: f.type,
            size: f.quality,
          }
        }),
        poster: this.poster,
      }
    },

    getFrameDetails({ segment, frameRate }) {
      if (segment) {
        // round to nearest frame number then multiply by framerate to get it to the nearest frame
        // work out the frame number
        let frameNumber = null
        let seek = segment.startTime
        // if we know the frame rate we can set the nearest frame
        if (frameRate) {
          frameNumber = Math.round(segment.startTime * frameRate)
          // and then get the start of that frame
          seek = frameNumber / frameRate
          // but the play can get this wrong, so we'll aim at the middle of a frame
          seek += 1 / frameRate / 2
        } else {
          // we dont know the framerate, so we'll use an arbitrary frame rate and jump half way in
          seek = segment.startTime + 1 / 25 / 2
        }
        return {
          segment,
          frameNumber,
          frameRate,
          seek,
        }
      }
    },

    levelSwitching(data) {
      this.levelBitrate = data.bitrate
      this.levelWidth = data.width
      this.levelHeight = data.height
      this.frameRate = data.attrs['FRAME-RATE']
      // TODO - set this with plyr video ratio or data from film file if hls not used
      this.videoRatio = `${this.levelWidth}x${this.levelHeight}`
      this.fps = this.frameRate
        ? this.frameRate
          .replace(/0+$/, '')
          .replace(/\.$/, '')
          .replace(/$/, 'fps')
        : ''
    },
    newFiles() {
      this.initPlayer()
      // now we need to set up hls
      this.setFiles()
      // intialize player stats
      this.setPlayerStats({
        filmID: this.filmMaster && this.filmMaster.filmID,
        currentTime: null,
        playing: false,
        filmMasterID: this.filmMaster && this.filmMaster.id,
        filmFileID: this.videoPlaying && this.videoPlaying.id,
        event: 'newFiles',
        floatRate: this.videoPlaying && this.floatRate
      })
    },

    setFiles() {
      const levelSwitching = (e, data) => this.levelSwitching(data)
      // need to destroy previous hls context if there was on
      if (this.hlsHandle) this.hlsHandle.destroy()
      if (this.canHls && this.filmFiles) {
        const hlsFile = this.getHlsFile
        if (hlsFile) {
          const hls = new Hls()
          hls.loadSource(hlsFile.path)
          hls.attachMedia(this.vid)
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            this.player.toggleControls(true)
          })
          hls.on(Hls.Events.LEVEL_SWITCHING, levelSwitching)
          this.hlsHandle = hls
        }
      }
    },

    objectTracking(atTime) {
      // clear up anything hanging around from before
      if (this.ctx) clearCanvas(this.ctx)
      // if we are actually tracking then show it
      if (this.showTracking) {
        // these will be all the things that need plotted right now

        const draws = this.findObjectsAtTime(atTime)

        // now draw them all, after dom settles down
        this.$nextTick(() => {
          // in case this isnt made yet
          this.setCanvas()

            // objects might not be retrieved yet so do nothing till they are
            ; (draws || []).forEach((f) =>
              drawBox(this.ctx, f.objectTracking, {
                opacity: 0.5,
                fill: '#E91E63',
                chip: {
                  color: '#FFFFFF',
                  text: f.description,
                },
              }),
            )
        })
      }
    },

    findObjectsAtTime(atTime) {
      if (!this.SlimLabels) return null
      // discover the segments in which the current time appears
      return this.SlimLabels.reduce((p, c) => {
        c.segments.forEach((f) => {
          if (f.startTime <= atTime && f.endTime >= atTime) {
            p.push({ ...c, ...f })
          }
        })
        return p
      }, [])
    },

    initPlayer() {
      this.player = this.$refs.plyr.player
      this.vid = this.$refs.vid

      this.player.on('ready', () => {
        // dont want to allow controls till hls manifest is ready
        this.playerReady = true
        this.player.toggleControls(false)
        const playerStats = {
          filmID: this.filmMaster && this.filmMaster.filmID,
          currentTime: null,
          playing: false,
          filmMasterID: this.filmMaster && this.filmMaster.id,
          filmFileID: this.videoPlaying && this.videoPlaying.id,
          event: 'timeupdate',
          ended: false
        }

        // we can only play one big video at once, although there may also be a thumbnail playing.
        // we can publush details of the big video in case its useful elsewhere
        if (this.big) {
          this.setPlayerStats(playerStats)
        }


        ['play', 'playing'].forEach((event) =>
          this.player.on(event, () => this.patchPlayerStats({
            playing: true,
            currentTime: this.player.currentTime,
            event,
            ended: false
          })))

          ;['pause'].forEach((event) =>
            this.player.on(event, () => this.patchPlayerStats({
              playing: false,
              currentTime: this.player.currentTime,
              event,
              ended: false
            })))

          ;['ended'].forEach((event) =>
            this.player.on(event, () => this.patchPlayerStats({
              playing: false,
              // this is a little hack to force it to replt when end
              currentTime: this.player.currentTime + 0.000001,
              event,
              ended: true
            })))


        this.player.on('timeupdate', () => {
          this.frameNumber = this.frameRate
            ? Math.floor(this.player.currentTime * this.frameRate)
            : null

          this.objectTracking(this.player.currentTime)
          this.stripProgress(this.player.currentTime)

          this.patchPlayerStats({
            currentTime: this.player.currentTime,
            event: 'timeupdate',
          })
        })
        this.player.on('enterfullscreen', () => {
          this.fullScreen = true
        })
        this.player.on('exitfullscreen', () => {
          this.fullScreen = false
        })

        this.player.on('seeked', () => {
          // we have to do this here because set currenttime is really async - once there, wecan do any outstanding playeraction
          // playaction should be set before setting the playsegment
          this.dealWithPlayerAction()
        })
        this.setPoster()
      })
    },

    setCanvas() {
      // possible that the canvas height and width might need reset if there's been resize of screen
      if (this.showTracking) {

        const c = this.sizeCanvas({
          refName: 'fid-player-canvas',
          // same width as the posterframe
          container: document.querySelector('.plyr__poster')

          //.. this used to come from this.player.elements.container but its  but wrong
        })
        if (!this.ctx) this.ctx = c.getContext('2d')
      }
    },

    // the refname is ref of the canvas
    // the container is the div it overlays
    sizeCanvas({ refName, container, forceHeight = null, forceWidth = null }) {

      // get the current height of the overlaid container
      // it may have changed
      const { clientHeight, clientWidth } = container
      const height = forceHeight === null ? clientHeight : forceHeight
      const width = forceWidth === null ? clientWidth : forceWidth
      const c = this.$refs[refName]
      if (!c) {
        console.log('couldnt find the requested canvas ref', refName)
        return null
      }

      // if the height or width of the container has changed, then we need to fix the canvas too
      if (c.height !== height || c.width !== width) {
        c.height = height
        c.width = width
      }
      // 
      return c
    },
    ...mapMutations(vxMaps.mutations),
  },

  beforeDestroy() {
    if (this.hlsHandle) {
      this.hlsHandle.destroy()
    }
    if (this.player) {
      this.player.destroy()
    }
  },

  data: () => ({
    stripElem: null,
    stripCtx: null,
    resizeObserver: null,
    showTracking: false,
    ctx: null,
    labelType: 'object-label',
    SlimLabels: null,
    player: null,
    fullScreen: false,
    vid: null,
    levelBitrate: null,
    levelWidth: null,
    levelHeight: null,
    videoRatio: null,
    seek: null,
    frameNumber: null,
    hlsHandle: null,
    playerReady: false,
    frameRate: null,
    fps: null
  }),

  computed: {
    stripHeight() {
      return this.big ? 30 : 20
    },
    stripWidth() {
      // use the same width as the ply controls
      const ctl = document.querySelector(".plyr__controls")
      return ctl && ctl.offsetWidth
    },
    stripClass() {
      return this.big
        ? "strip-class fid-relative pb-4 mt-2"
        : "strip-class fid-relative"
    },
    strip() {
      const f = this.filmMaster
      const a = f && f.StripArtifact
      return f && f.stripUrl && a && a.SignedUrl && a.SignedUrl.url
    },
    floatRate() {
      // framerate can be some text
      // fps is the presentable version of that
      // floatRate is the numeric version
      return this.frameRate
        ? parseFloat(this.frameRate)
        : (this.videoPlaying && this.videoPlaying.fps) || 25
    },
    trackingDisabled() {
      return false
    },
    showSheek() {
      return this.frameNumber !== null
    },
    hostLogo() {
      return this.videoHost === 'vimeo' ? vimeoLogo : hitoLogo
    },
    arColor() {
      return getIconColor('ar')
    },
    frColor() {
      return getIconColor('fr')
    },
    brColor() {
      return getIconColor('br')
    },
    seekColor() {
      return getIconColor('seek')
    },
    formatColor() {
      return getIconColor(this.videoFormat) || 'accent'
    },
    isVimeoEmbed() {
      return this.playerMethod === 'vimeo-embed'
    },
    isYoutubeEmbed() {
      return this.playerMethod === 'youtube-embed'
    },
    isFid() {
      return this.playerMethod === 'fid'
    },
    bigEnough() {
      return this.$vuetify.breakpoint.smAndUp
    },
    duration() {
      return this.filmMaster && this.filmMaster.duration
    },
    videoHost() {
      return this.filmMaster && this.filmMaster.hostType
    },
    filmMasterID() {
      return this.filmMaster && this.filmMaster.id
    },
    videoFormat() {
      return this.videoPlaying && this.videoPlaying.distributionFormat
    },
    vimeoUrl() {
      const id = this.vimeoFile && this.vimeoFile.id
      const html =
        this.vimeoFile &&
        this.vimeoFile.embed &&
        this.vimeoFile.embed &&
        this.vimeoFile.embed.html
      const url =
        (html && html.match(/http[s]:.+(?=\?)/)) ||
        `https://player.vimeo.com/video/${id}`
      if (this.vimeoFile && !url)
        console.log('expected to find vimeourl', this.vimeoFile)
      return url
    },
    videoPlaying() {
      return (
        this.player &&
        (this.getHlsFile ||
          this.filmFiles.find((f) => f.path === this.player.source))
      )
    },
    getHlsFile() {
      return (
        this.filmFiles &&
        this.filmFiles.find((f) => f.distributionFormat === 'hls')
      )
    },
    canHls() {
      return Hls.isSupported()
    },
    supported() {
      // strip out any hls files
      const sups =
        this.filmFiles &&
        this.filmFiles.filter((f) => f.distributionFormat !== 'hls')

      // make the source file the last choice
      const source = sups.filter((f) => f.source)
      const nonSource = sups.filter((f) => !f.source)
      return source.concat(nonSource)
    },
    qualities() {
      // make an array of qualities to select from supported files and dedeup
      return (
        this.supported &&
        this.supported
          .map((f) => f.quality)
          .filter((f, i, a) => a.indexOf(f) === i)
      )
    },
    quality() {
      // make a quality object - default is hls if it exists, or lowest quality for small, highest quality for big
      // if hls exists then this will be irrelevant
      return this.qualities
        ? {
          default: this.big
            ? Math.max(...this.qualities)
            : Math.min(...this.qualities),
          options: this.qualities,
        }
        : null
    },
    controls() {
      const bigControls = [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'settings',
        'pip',
        'airplay',
        'fullscreen',
      ]
      const smallControls = ['play', 'volume', 'mute', 'fullscreen']
      const quiteBigControls = bigControls.filter(
        (f) => f !== 'current-time' && f !== 'pip',
      )
      const fullScreenControls = bigControls
      // we can adapt controls depending on what mode we are in
      // but this doesnt work as cant change controls on the fly - TODO
      if (this.fullScreen) {
        return fullScreenControls
      } else if (this.big) {
        return this.bigEnough ? bigControls : quiteBigControls
      } else {
        return smallControls
      }
    },
    options() {
      return {
        autoplay: this.autoplay,
        settings: this.getHlsFile ? ['speed'] : ['quality', 'speed'],
        controls: this.controls,
        quality: this.quality,
        storage: {
          enabled: false,
        },
      }
    },
    ...mapState(vxMaps.state),
  },
  apollo: {
    SlimLabels: {
      skip() {
        return !this.filmMasterID || !this.showTracking
      },
      query: SlimLabels,
      variables() {
        return {
          limit: 2000,
          filters: [
            {
              valueKey: 'filmMasterID',
              value: this.filmMasterID,
            },
            {
              valueKey: 'type',
              value: this.labelType,
            },
          ],
        }
      },
    },
  },
}
</script>
